import { useReveal, useWindowEvent } from '@ccg/core';
import React$1, { useRef, useState, useCallback, useEffect } from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledCategoryTeaser from './CategoryTeaser.style.js';

const CategoryTeaser = ({
  index,
  headline,
  cta,
  subline,
  link,
  orientation
}) => {
  const [ref, isVisible] = useReveal();
  const headlineRef = useRef(null);
  const [height, setHeight] = useState();
  const handleResize = useCallback(() => {
    if (orientation === 'horizontal') return;

    if (headlineRef.current) {
      const rect = headlineRef.current.getBoundingClientRect();
      setHeight(rect.height);
    }
  }, [headlineRef, setHeight]);
  useEffect(() => handleResize(), []);
  useWindowEvent('resize', () => handleResize());
  return /*#__PURE__*/React$1.createElement(StyledCategoryTeaser, {
    className: "categoryTeaser",
    ref: ref,
    isVisible: isVisible,
    orientation: orientation,
    isEven: index % 2 === 0,
    height: height
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "categoryTeaser__link",
    noHover: true
  }, link), /*#__PURE__*/React$1.createElement("div", {
    className: "categoryTeaser__headline"
  }, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "intro",
    text: headline,
    ref: headlineRef
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "categoryTeaser__content"
  }, subline && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "categoryTeaser__subline",
    variant: "subline"
  }, subline), cta && /*#__PURE__*/React$1.createElement("div", {
    className: "categoryTeaser__cta"
  }, cta))));
};

CategoryTeaser.propTypes = {
  index: PropTypes$1.number,
  cta: PropTypes$1.string,
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  link: PropTypes$1.shape(),
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical'])
};
CategoryTeaser.defaultProps = {
  index: 0,
  cta: null,
  subline: null,
  link: {},
  orientation: 'horizontal'
};

export default CategoryTeaser;
